/**
 * AUTO-GENERATED from src/styles/theme.css by scripts/gen-tokens.cjs. DO NOT EDIT.
 * theme.css is the single source of truth for token values; this mirrors it for JS contexts
 * (Recharts, board squares, Clerk, inline styles) that cannot read CSS vars. Regenerate:
 *   npm run gen-tokens   (also runs on prestart/prebuild)
 */
export const tokens = {
  "--color-bg-base": "oklch(13.9% 0.014 258)",
  "--color-bg-surface": "oklch(18% 0.014 258)",
  "--color-bg-elevated": "oklch(21% 0.014 258)",
  "--color-bg-hover": "oklch(37.3% 0.034 259.733)",
  "--color-bg-inset": "#0d0e0f",
  "--color-bg-neutral": "oklch(21% 0.034 264.665)",
  "--color-bg-void": "#000000",
  "--color-surface": "oklch(18% 0.014 258)",
  "--color-elevated": "oklch(21% 0.014 258)",
  "--color-canvas": "oklch(13.9% 0.014 258)",
  "--color-neutral": "oklch(21% 0.034 264.665)",
  "--color-void": "#000000",
  "--color-hover": "oklch(37.3% 0.034 259.733)",
  "--color-inset": "#0d0e0f",
  "--color-background": "oklch(13.9% 0.014 258)",
  "--color-card": "oklch(18% 0.014 258)",
  "--color-popover": "oklch(21% 0.014 258)",
  "--color-secondary": "oklch(21% 0.014 258)",
  "--color-muted": "oklch(18% 0.014 258)",
  "--color-border": "rgba(255, 255, 255, 0.06)",
  "--color-border-muted": "rgba(255, 255, 255, 0.035)",
  "--color-border-hover": "oklch(37.3% 0.034 259.733)",
  "--color-text-primary": "oklch(98.5% 0.004 258)",
  "--color-text-prose": "oklch(92.8% 0.010 258)",
  "--color-text-voice": "oklch(93% 0.012 75)",
  "--color-text-secondary": "oklch(71% 0.014 258)",
  "--color-text-nav": "oklch(78% 0.014 258)",
  "--color-text-tertiary": "oklch(63% 0.014 258)",
  "--color-text-ghost": "oklch(37.3% 0.034 259.733)",
  "--color-text-disabled": "oklch(44.6% 0.03 256.802)",
  "--color-text-on-accent": "#ffffff",
  "--color-accent": "#3b82f6",
  "--color-accent-hover": "#2563eb",
  "--color-accent-muted": "rgba(59, 130, 246, 0.15)",
  "--color-accent-text": "#60a5fa",
  "--color-success": "#3fb950",
  "--color-success-muted": "rgba(63, 185, 80, 0.15)",
  "--color-warning": "#d29922",
  "--color-warning-muted": "rgba(210, 153, 34, 0.15)",
  "--color-error": "#ef4444",
  "--color-error-muted": "rgba(239, 68, 68, 0.15)",
  "--text-xs": "12px",
  "--text-sm": "13px",
  "--text-base": "15px",
  "--text-lg": "18px",
  "--text-xl": "22px",
  "--text-2xl": "28px",
  "--text-3xl": "36px",
  "--text-4xl": "48px",
  "--leading-tight": "1.2",
  "--leading-normal": "1.5",
  "--leading-relaxed": "1.6",
  "--tracking-tight": "-0.02em",
  "--tracking-normal": "-0.01em",
  "--tracking-wide": "0.01em",
  "--font-regular": "400",
  "--font-medium": "500",
  "--font-semibold": "600",
  "--font-bold": "700",
  "--space-1": "4px",
  "--space-2": "8px",
  "--space-3": "12px",
  "--space-4": "16px",
  "--space-5": "20px",
  "--space-6": "24px",
  "--space-8": "32px",
  "--space-12": "48px",
  "--space-16": "64px",
  "--radius-sm": "6px",
  "--radius-md": "6px",
  "--radius-lg": "12px",
  "--card-bg": "rgba(255, 255, 255, 0.02)",
  "--card-border": "rgba(255, 255, 255, 0.06)",
  "--card-border-hover": "rgba(255, 255, 255, 0.12)",
  "--card-radius": "12px",
  "--chart-baseline": "rgba(255, 255, 255, 0.12)",
  "--chart-gridline": "rgba(255, 255, 255, 0.05)",
  "--shadow-none": "none",
  "--shadow-btn": "0 2px 8px rgba(47,129,247,0.25)",
  "--shadow-btn-hover": "0 4px 14px rgba(47,129,247,0.35)",
  "--shadow-overlay": "0 8px 32px rgba(0,0,0,0.5)",
  "--tint-bg": "0.08",
  "--tint-border": "0.15",
  "--tint-icon": "0.08",
  "--font-sans": "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  "--font-display": "'Bricolage Grotesque', 'Avenir Next', system-ui, sans-serif",
  "--font-mono": "'JetBrains Mono', 'Fira Code', 'Consolas', monospace",
  "--font-voice": "'Lora', Georgia, 'Times New Roman', serif",
  "--cls-brilliant": "#1baca6",
  "--cls-brilliant-border": "#0e7872",
  "--cls-great": "#749BBF",
  "--cls-great-border": "#4d7194",
  "--cls-great-sq-from": "#AFC4C8",
  "--cls-great-sq-to": "#AFC4C8",
  "--cls-excellent": "#81B64C",
  "--cls-excellent-border": "#5e8a36",
  "--cls-excellent-sq-from": "#B6D290",
  "--cls-excellent-sq-to": "#7AA54F",
  "--cls-good": "#95B776",
  "--cls-good-border": "#6d8a5e",
  "--cls-good-sq-from": "#84A665",
  "--cls-good-sq-to": "#C0D2A4",
  "--cls-opening": "#D5A47D",
  "--cls-opening-border": "#a87c54",
  "--cls-opening-sq-from": "#E0C9A7",
  "--cls-opening-sq-to": "#A49C68",
  "--cls-forced": "#64748b",
  "--cls-forced-border": "#475569",
  "--cls-inaccuracy": "#F7C632",
  "--cls-inaccuracy-border": "#c49a1a",
  "--cls-inaccuracy-sq-from": "#F5E68F",
  "--cls-inaccuracy-sq-to": "#C7B15C",
  "--cls-mistake": "#FB8C2A",
  "--cls-mistake-border": "#c96d16",
  "--cls-mistake-sq-from": "#F5C996",
  "--cls-mistake-sq-to": "#BA9D56",
  "--cls-blunder": "#FA412E",
  "--cls-blunder-border": "#c42f1f",
  "--cls-blunder-sq-from": "#F49A81",
  "--cls-blunder-sq-to": "#B96F41",
  "--cls-missed": "#F6B39D",
  "--severity-hung": "#FA412E",
  "--severity-allowed": "#FFA459",
  "--severity-missed": "#F7C632",
  "--severity-played": "#8b9dc3",
  "--chip-context": "#b08968",
  "--go": "#43D66A",
  "--go-deep": "#23913F",
  "--accuracy-high": "#4ade80",
  "--accuracy-good": "#86efac",
  "--accuracy-mid": "#eab308",
  "--accuracy-low": "#f87171",
  "--accuracy-neutral": "#7d8590",
  "--wr-win": "#3fb950",
  "--wr-even": "#d29922",
  "--wr-loss": "#ef4444",
  "--glass-bg": "oklch(20.5% 0.016 258)",
  "--glass-border": "rgba(255, 255, 255, 0.13)",
  "--glass-border-hover": "rgba(255, 255, 255, 0.20)",
  "--glass-divider": "rgba(255, 255, 255, 0.04)",
  "--glass-tint": "rgba(255, 255, 255, 0.04)",
  "--glass-shadow": "0 10px 28px rgba(0, 0, 0, 0.5), 0 2px 6px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.07)",
  "--palette-tactical": "#f85149",
  "--palette-calculation": "#d29922",
  "--palette-king-safety": "#e3b341",
  "--palette-endgame-pawn": "#3fb950",
  "--palette-endgame-piece": "#58a6ff",
  "--palette-game-state": "#bc8cff",
  "--palette-process": "#f778ba",
  "--palette-neutral": "#6b7280",
  "--piece-white": "#e8e8e8",
  "--piece-black": "#333333",
  "--board-dark": "#4b7399",
  "--board-light": "#dde7ee",
  "--eval-white": "#b9c7d6",
  "--eval-black": "#0b0e12",
  "--eval-black-bottom": "#1a2230",
  "--eval-zero-line": "rgba(47, 129, 247, 0.18)",
  "--scrollbar-track": "oklch(18% 0.014 258)",
  "--scrollbar-thumb": "oklch(63% 0.014 258)",
  "--scrollbar-thumb-hover": "oklch(71% 0.014 258)",
  "--color-bg-card": "oklch(18% 0.014 258)",
  "--color-warning-dim": "rgba(210, 153, 34, 0.08)",
  "--color-error-dim": "rgba(248, 81, 73, 0.07)",
  "--color-success-dim": "rgba(63, 185, 80, 0.08)",
  "--color-accent-dim": "rgba(47, 129, 247, 0.08)",
  "--font-dm-sans": "'DM Sans', var(--font-sans)",
  "--bg-panel": "oklch(18% 0.014 258)",
  "--bg-slate-950": "oklch(13.9% 0.014 258)",
  "--bg-slate-900": "oklch(18% 0.014 258)",
  "--bg-slate-800": "oklch(21% 0.014 258)",
  "--bg-midnight": "#0d0e0f",
  "--border-subtle": "rgba(255, 255, 255, 0.06)",
  "--border-active": "#3b82f6",
  "--border-slate": "rgba(255, 255, 255, 0.06)",
  "--text-main": "oklch(98.5% 0.004 258)",
  "--text-muted": "oklch(71% 0.014 258)",
  "--text-body": "rgba(230, 237, 243, 0.74)",
  "--text-white": "oklch(98.5% 0.004 258)",
  "--text-slate-100": "oklch(98.5% 0.004 258)",
  "--text-slate-300": "oklch(71% 0.014 258)",
  "--text-slate-400": "oklch(71% 0.014 258)",
  "--text-slate-500": "oklch(63% 0.014 258)",
  "--text-gray-400": "oklch(71% 0.014 258)",
  "--accent-blue": "#60a5fa",
  "--accent-blue-600": "#3b82f6",
  "--accent-blue-700": "#2563eb",
  "--accent-green-500": "#3fb950",
  "--accent-red-500": "#ef4444",
  "--accent-yellow-400": "#d29922",
  "--accent-yellow-500": "#d29922",
  "--deck-border": "rgba(47, 129, 247, 0.35)",
  "--deck-border-active": "rgba(47, 129, 247, 0.55)",
  "--deck-bg": "rgba(47, 129, 247, 0.05)",
  "--deck-bg-hover": "rgba(47, 129, 247, 0.08)",
  "--deck-glow": "0 0 14px rgba(47, 129, 247, 0.14)",
  "--deck-inset": "inset 0 0 0 1px rgba(47, 129, 247, 0.12)",
  "--slab-bg-from": "#1a2744",
  "--slab-bg-to": "#0f1b2e",
  "--slab-border": "#2a3f5c",
  "--slab-edge-1": "#0c1424",
  "--slab-edge-2": "#1a2744",
  "--slab-edge-3": "#0a1020",
  "--slab-highlight": "rgba(255, 255, 255, 0.05)",
  "--panel-bg-from": "#0e141e",
  "--panel-bg-to": "#0a0f18",
  "--panel-border": "#1a2840",
  "--nav-h": "48px",
  "--radius-card": "6px",
  "--radius-chip": "6px",
  "--radius-tab": "6px",
  "--font-mono-alt": "'JetBrains Mono', 'Fira Code', 'Consolas', monospace"
} as const;

export type TokenName = keyof typeof tokens;
